import { useNavigate } from '@tanstack/react-router'
import type { AiReportData } from '@workspace/seedforge-features/analytics'
import { DeepInsightsTab } from '@workspace/seedforge-features/analytics'
import { useAnalyticsQuery, useInsightsReportQuery } from '../../../hooks/api'
import { ShareHintBar } from './share-hint-bar'

interface DeepInsightsPanelProps {
  startupId: string
}

export function DeepInsightsPanel({ startupId }: DeepInsightsPanelProps) {
  const navigate = useNavigate()

  const { data: analyticsData, isLoading: isAnalyticsLoading } = useAnalyticsQuery(startupId)
  const { data: insightsData } = useInsightsReportQuery(startupId)

  const insightsRaw = insightsData?.data as
    | {
        report: AiReportData | null
        generatedAt: string | null
        totalVisitorsUnfiltered?: number
      }
    | undefined
  const aiReport = (insightsRaw?.report as AiReportData | null) ?? null
  const aiReportGeneratedAt = insightsRaw?.generatedAt ?? null

  const aggregates = analyticsData?.data?.aggregates ?? null

  if (isAnalyticsLoading) {
    return <div className="p-6 text-sm text-muted-foreground">Loading…</div>
  }
  if (!analyticsData?.data) return null

  return (
    <div className="space-y-6">
      <ShareHintBar startupId={startupId} />
      <DeepInsightsTab
        aggregates={aggregates}
        aiReport={aiReport}
        aiReportGeneratedAt={aiReportGeneratedAt}
        analyticsFilter={analyticsData?.data?.analyticsFilter}
        onManageAnalyticsFilter={() =>
          navigate({ to: '/app/startup/$id/settings/analytics', params: { id: startupId } })
        }
      />
    </div>
  )
}
